import React from "react";
import CtaSection from "../Components/internal-pages/Cta_Section";
import { Helmet } from "react-helmet";
import LeftImgrightContent from "../Components/internal-pages/Leftimg_rightContent";
import RightimgLeftContent from "../Components/internal-pages/Rightimg_leftContent";
import NogapRightImage from "../Components/internal-pages/No_gap_right_Img";
import Whychooseus from "../Components/internal-pages/WhyChooseus";
import ClinetsLogoSlider from "../Components/home/ClientsLogoSlider";

const FestiveGifitng = () => {
  const CTAFestiveGifting = [
    {
      pageName: "Festive Giftings",
      paragraphitalic:
        "Celebrate the Spirit of Festivities with Thoughtful Gifts",
      paragraphText:
        "Festivals are more than just occasions – they’re opportunities to strengthen bonds, spark joy, and create a lasting impression. At eYantra, our Festive Gifting Solutions are designed to help your brand shine through thoughtful, high-quality, and memorable gifts for every celebration.",
      ContactFormName: "Festive-Gifting",
    },
  ];
  const ContentImg = [
    {
      index: 0,
      leftImg: "./assests/images/banners/New Year Gifts.jpg",
      leftHeading: "New Year Gifts",
      leftSmallpara: "Start the Year with a Bang!",
      leftParagraph:
        "Welcome the new beginnings with gifts that inspire excitement and set the tone for the year ahead. From elegant planners to premium hampers, our curated New Year gifts will leave a lasting impact on your clients and employees alike.",
      leftRedirectUrl: "/festive-gifting/new-year-gifts",
    },
    {
      index: 1,
      leftImg: "./assests/images/banners/Christmas Gifts.jpg",
      leftHeading: "Christmas Gifts ",
      leftSmallpara: "Add a Dash of Holiday Cheer",
      leftParagraph:
        "Spread the joy of the festive season with Christmas gifts that embody warmth and celebration. From cozy hampers to delightful chocolates, our Christmas collection is perfect for making spirits bright.",
      leftRedirectUrl: "/festive-gifting/christmas-gifts",
    },
  ];
  const rightImgContent = [
    {
      index: 0,
      rightImg: "./assests/images/banners/Diwali Gifts.jpg",
      rightHeading: "Diwali Gifts",
      rightSmallpara: "Light Up Every Moment ",
      rightParagraph:
        "Celebrate the festival of lights with gifts that illuminate relationships and bring smiles. From traditional sweets to modern gadgets, our Diwali gifting options blend tradition with contemporary charm. ",
      rightRedirectUrl: "/festive-gifting/diwali-gifts",
    },
  ];
  const NoGapContent = [
    {
      NogaprightImg: "./assests/images/banners/Other Festive Gifts.jpg",
      NogaprightHeading: "Other Festive Gifts ",
      NogaprightSmallpara: "Celebrate Every Occasion, Big or Small ",
      NogaprightParagraph: "India is a land of celebrations, and every festival is an opportunity to connect and engage. Whether it’s Holi, Raksha Bandhan, or a regional festival, we’ve got unique gifting solutions for all occasions. ",
      NogaprightRedirectUrl: "/festive-gifting/other-festive-gifts",
    },
  ];

  return (
    <>
      <Helmet>
        <title>eYantra Presents Customized Festive & Corporate Gifts</title>
        <meta name="description" content="Shop onboarding kits, festive gifting, and branded corporate gifts. eYantra offers customized gifts and employee rewards for every occasion."/>
        <meta name="keywords" content="eyantra, festive gifting, customized gifts, joining kits, employee rewards and recognitions, onboarding kits, corporate gifts for employees, welcome kits, branded corporate"/>

      </Helmet>
      <div className="p-0 m-2">
      <div className="p-0 m-0">
        <CtaSection data={CTAFestiveGifting} />
      </div>
      <LeftImgrightContent leftImgContent={ContentImg[0]} />
      <RightimgLeftContent data={rightImgContent[0]} />
      <LeftImgrightContent leftImgContent={ContentImg[1]} />
      <NogapRightImage data={NoGapContent[0]} />
      </div>
      <div className="my-5">
            <ClinetsLogoSlider/>
        </div>
        <Whychooseus/>
      
    </>
  );
};

export default FestiveGifitng;
